import gql from 'graphql-tag';

export const CreateBabyQuery = gql`
  mutation CreateBaby(
    $dob: date
    $gender: private_gender_enum
    $name: String
    $delivery: private_baby_delivery_mode_enum!
    $preterm: Boolean!
  ) {
    insert_baby_one(
      object: {
        dob: $dob
        gender: $gender
        name: $name
        delivery: $delivery
        preterm: $preterm
      }
    ) {
      id
      gender
      name
      dob
      delivery
      preterm
      parent_id
    }
  }
`;
